import axios from 'axios';

import { showAlert } from './alerts';



export const ratingForm = async (formDataObject) => {

	try {

		const { gameID, gameSlug, reviewID } = formDataObject;

		const method = reviewID ? 'PATCH' : 'POST';

		const url = reviewID
			? `/api/v1/reviews/${reviewID}`
			: `/api/v1/games/${gameID}/reviews`;


		const result = await axios({

			method,
			url,
			data: formDataObject,
			headers: { 'Content-Type': 'application/json' },

		});


		if (result.data.status === 'success') {
			showAlert('success', 'Ratings Submitted Successfully!!');


			window.setTimeout(() => {
				location.assign(`/game/${gameSlug}`)
			}, 1500)



		}
	} catch (err) {

		console.error('API Error:', err.response?.data || err);

		if (err.response?.data) {

			console.log('Error Details:', JSON.stringify(err.response.data, null, 2));
		}

		showAlert('error', 'Error submitting review');
	}
};



